jQuery(document).ready(function ($) {
//    var parameters = getQueryStringParameters();
//    if(isEmpty(parameters) == false) {
//      $.each(parameters, function(key, value) {
//        if(key == 'age' && value == 'true'){
//             $('.popup-confirmation').css('display', 'none');

//        }
//      });
//    }
  
  jQuery('.close-popup').on('click', function(){
    	$(this).parent().parent().css('display', 'none');
  });
  
  jQuery('.open-popup').on('click', function(){
    	$('.gpopup').css('display', 'block');
  });
  
  	var date = document.getElementById('mce-MMERGE1');

	function checkValue(str, max) {
	  if (str.charAt(0) !== '0' || str == '00') {
	    var num = parseInt(str);
	    if (isNaN(num) || num <= 0 || num > max) num = 1;
	    str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
	  };
	  return str;
	};

	
    date.addEventListener('input', function(e) {
      this.type = 'text';
      var input = this.value;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = checkValue(values[0], 12);
      if (values[1]) values[1] = checkValue(values[1], 31);
      var output = values.map(function(v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      this.value = output.join('').substr(0, 14);
    });

    date.addEventListener('blur', function(e) {
      this.type = 'text';
      var input = this.value;
      var values = input.split('/').map(function(v, i) {
        return v.replace(/\D/g, '')
      });
      var output = '';

      if (values.length == 3) {
        var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
        var month = parseInt(values[0]) - 1;
        var day = parseInt(values[1]);
        var d = new Date(year, month, day);
        if (!isNaN(d)) {
          document.getElementById('result').innerText = d.toString();
          var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
          output = dates.map(function(v) {
            v = v.toString();
            return v.length == 1 ? '0' + v : v;
          }).join(' / ');
        };
      };
      this.value = output;
    });

    jQuery("#postcode").keyup(function() {
      var maxChars = 4;
      if (jQuery(this).val().length > maxChars) {
        jQuery(this).val(jQuery(this).val().substr(0, maxChars));
      }
    });
  
    // init Isotope
    var $grid = $('.grid_retailers').isotope({
      // options
    });
    // filter items on button click
    $('.filter-button-group').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });
    });
	

    if($('.thankyou-close').length){
		
      	setTimeout(function(){ window.close(); }, 2000);
    }
});

function getQueryStringParameters() {
  var parameters = {}, hash;
  var q = document.URL.split('?')[1];
  if(q != undefined) {
    q = q.split('&');
    for(var i = 0; i < q.length; i++) {
      hash = q[i].split('=');
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

function isEmpty(obj) {
   for(var key in obj) {
   if(obj.hasOwnProperty(key))
   return false;
   }
   return true;
}